import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type EntityMediaFragment = { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null };


export type EntityMediaFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const EntityMediaFragmentDoc = /*#__PURE__*/ gql`
    fragment EntityMedia on EntityMediaType {
  name
  description
  url
  size
  mimeType
  mediaId
  kind
  resolutions {
    type
    url
  }
}
    `;